"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentSignalInferenceReportEntrySchema = void 0;
const zod_1 = require("zod");
const Signal_1 = require("../DesignModels/Signal");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
exports.ComponentSignalInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('specified')
        .or(zod_1.z.literal('partner'))
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil')),
    priority: zod_1.z.number().optional(),
    signalId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    properties: zod_1.z.lazy(() => Signal_1.SignalSchema.omit({ id: true, name: true, pinRefs: true, padRefs: true })),
});
//# sourceMappingURL=ComponentSignalInferenceReportEntry.js.map